import Apagination from "../Apagination";

export default {
  name: 'Apages',
  render() {
    const attrs = this.$attrs;
    const on = this.$listeners;
    return (<Apagination class="a-pages" {...{ attrs }} {...{ on }} />);
  }
}